import { frontendURL } from 'dashboard/helper/URLHelper';
const QueueMetrics = () => import('./QueueMetrics.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/queuemetrics'),
    name: 'queue_metrics',
    component: QueueMetrics,
    roles: ['administrator', 'agent', 'supervisor', 'master'],
  },
];
